export default __webpack_public_path__ + "static/media/logo-xl-1920w.848648a9.webp";